
import { useState, useEffect, useCallback } from 'react';

export const useSuggestionDismissal = (userId: string) => {
  // In a real app, this would use localStorage or a database to persist dismissals
  const [dismissedSuggestions, setDismissedSuggestions] = useState<string[]>([]);
  
  // Load dismissed suggestions from localStorage (if available in browser environment)
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const savedDismissals = localStorage.getItem(`dismissed-suggestions-${userId}`);
      if (savedDismissals) {
        try {
          setDismissedSuggestions(JSON.parse(savedDismissals));
        } catch (err) {
          console.error('Error parsing dismissed suggestions', err);
        }
      }
    }
  }, [userId]);
  
  // Save dismissed suggestions to localStorage
  const saveDismissals = useCallback((dismissals: string[]) => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(`dismissed-suggestions-${userId}`, JSON.stringify(dismissals));
    }
  }, [userId]);
  
  // Dismiss a suggestion
  const dismissSuggestion = useCallback((id: string) => {
    setDismissedSuggestions(prev => {
      const updated = [...prev, id];
      saveDismissals(updated);
      return updated;
    });
  }, [saveDismissals]);
  
  // Check if a suggestion is dismissed
  const isSuggestionDismissed = useCallback((id: string) => {
    return dismissedSuggestions.includes(id);
  }, [dismissedSuggestions]);
  
  // Reset dismissed suggestions
  const resetDismissals = useCallback(() => {
    setDismissedSuggestions([]);
    saveDismissals([]);
  }, [saveDismissals]);
  
  return {
    dismissSuggestion,
    isSuggestionDismissed,
    resetDismissals,
    dismissedCount: dismissedSuggestions.length
  };
};
